export function isParentQuestion(q) {
  return !!q && (!q.fatherQuestionId || q.hasSubQuestion);
}

export function isSubQuestion(q) {
  return !!q?.fatherQuestionId;
}

export function shouldShowSubQuestion(parentQuestion = {}, subQuestion = {}) {
  if (!parentQuestion?.id || parentQuestion.id !== subQuestion?.fatherQuestionId) return false;
  const questionTrigger =
    Array.isArray(parentQuestion?.questionTrigger) && parentQuestion.questionTrigger.length
      ? parentQuestion.questionTrigger
      : (parentQuestion.responses || []).filter((response) => response?.triggerSubQuestion);
  if (!questionTrigger.length) return false;
  const isSelectedTrigger = (parentQuestion.responses || []).find((response) => {
    return questionTrigger.find((trigger) => response.id === trigger.id && response.selected);
  });
  return !!isSelectedTrigger;
}

export function groupQuestionsWithSubQuestions(list = []) {
  const parents = (list || []).filter((q) => isParentQuestion(q) || !isSubQuestion(q));
  const subsByParent = new Map();
  (list || [])
    .filter((q) => isSubQuestion(q))
    .forEach((sub) => {
      const arr = subsByParent.get(sub.fatherQuestionId) || [];
      arr.push(sub);
      subsByParent.set(sub.fatherQuestionId, arr);
    });
  return parents.map((p) => ({ parent: p, subQuestions: subsByParent.get(p.id) || [] }));
}
